module.exports = __webpack_public_path__ + "img/maipu-automotores.a77d360d.jpg";